import React from "react";

export default function PostPage() {
  return <div>PostPage</div>;
}
